import React, { useState, useEffect, useContext } from 'react';
import { main_links } from 'config';
import imgLogo from 'assets/images/header/logo-header.png';
import PopupLayout from 'components/PopupLayout';
import PopupWelcome from 'components/PopupWelcome';
import SvgIconInfo from 'components/Svg/iconinfo';
import SvgIconCoupons from 'components/Svg/iconcoupons';
//import SvgIconSearch from 'components/Svg/iconsearch';
import SvgIconAccount from 'components/Svg/iconaccount';
import { CartContext } from '../../cart/CartContext';
import { AuthContext } from '../../auth/AuthContext';
import CartFactory from 'factories/Cart';
import { types } from '../../types/types';
import LoginService from 'services/Login/service';
import moment from 'moment';





const Header = () => {

    const { sessionData, sessionDispatch} = useContext(AuthContext);
    const { cartDispatch } = useContext(CartContext);
    const [showMenuAccount, setShowMenuAccount] = useState(false);
    const [showWelcome, setShowWelcome] = useState(false);
    const [stickyClass, setStickyClass] = useState('');
    const openSubMenu = (event) => {
        event.preventDefault();
        setShowMenuAccount(!showMenuAccount);
    }
    const openWelcome = (event, forceValue = 'none') => {
        event.preventDefault();
        setShowWelcome(forceValue === 'none' ? !showWelcome : (forceValue));
    }
    const stickyHeader = (_offset) => {
        const headerPos = document.getElementsByTagName('header')[0].offsetHeight;
        if(_offset > headerPos){
            setStickyClass('sticky-header');
        }else{
            setStickyClass('');
        }
    }
    useEffect(() => {
        window.onscroll = () => {
            if(window.pageYOffset<0)
                 return;
             stickyHeader(window.pageYOffset);
        }
        return () => {window.onscroll = null}
    }, []);


    const logout = () => {
        cartDispatch({
            type: types.update,
            payload: CartFactory.reset()
        });

        sessionDispatch({
            type: types.logout
        });

        usuarioLogEvent();
    }
    
    //UsuarioLog
    const usuarioLogEvent = async()=>{
        
        try{

        //timeSession
        const inicioSession=sessionData.inicioSession;
        const cierreSession = moment(new Date());
        const timeSession=cierreSession.diff(inicioSession,'seconds');//rpt
        // get ip public;
        const ip_public = await LoginService.ipifyIpPublic();
        

        //creation user log
        LoginService.crearUsuarioLog({

        "internalCode": "200",
        "jwt":sessionData.tokenLogUsuario,
        "correo":sessionData.email,
        "ipPublica":ip_public,
        "tipoEvento":"Sign out ("+sessionData.scope+")",
        "timeSessionSeconds":timeSession,
        "descripcion":"",
        "socialScope":sessionData.scope

        });

        }catch(error){
            console.error(error);
        }
        
    
    };

    return (
        <>
        <header className={stickyClass}>
            <nav className="navbar navbar-expand-lg h-100">
                <div className="container menu h-100">
                    <div className="navbar-brand">
                        <div className="row h-100">
                            <div className="col-12 my-auto">
                                <a href={sessionData.logged ? main_links.main_logged : main_links.main}>
                                    <img src={imgLogo} alt="Metro"/>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row buttons float-right ml-auto mr-0">
                        <div className="col-md-12 my-auto">
                            <div className="row">
                            {sessionData.logged ?
                                <>
                                    <div className="col-auto p-0 d-flex">
                                        <a href="#" className="btn-logged-info" onClick={(event)=>openWelcome(event)}>
                                            <SvgIconInfo />
                                        </a>
                                        <a href={main_links.cart} className="btn-logged-coupons">
                                            <SvgIconCoupons />
                                        </a>
                                        {/*
                                        <a href="#" className="btn-logged-search">
                                            <SvgIconSearch />
                                        </a>
                                        */
                                        }
                                    </div>
                                    <div className="col d-none d-md-flex account-info flex-column">
                                        {sessionData.fullname
                                        ?
                                            <p className={`text-right ${sessionData.bonus?'mb-1':'m-0'}`}>
                                                 <a href="#">Bienvenido(a),<br/><strong>{sessionData.fullname}</strong></a>
                                            </p>
                                        :
                                            <p className="text-right mt-3">
                                                <strong>Bienvenido(a)</strong>
                                            </p>
                                        }
                                        {sessionData.bonus &&
                                             <p className="text-right my-0 account-info-bonus">
                                                 Excelente! estás vinculado con tu <span className="default-red">tarjeta bonus</span>
                                             </p>
                                         }
                                    </div>
                                    <div className="col-auto p-0 d-flex content-logged-account">
                                        <a onClick={(e) => openSubMenu(e)} href="#" className="btn-logged-account">
                                            <SvgIconAccount />
                                        </a>
                                        <div className={'row submenu' + (showMenuAccount?' opened':'')}>
                                            <div className="col-12">
                                                <ul>
                                                    <li><a href={main_links.my_account}>Mi cuenta</a></li>
                                                    <li><a href={main_links.my_coupons}>Mis cupones</a></li>
                                                    <li><a href="#" onClick={logout}><strong>Cerrar sesión</strong></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                <div className="buttons mx-2">
                                    <a href={main_links.login} className="btn no-hover">
                                        <span>Iniciar sesión</span>
                                    </a>
                                    <a href={main_links.register} className="btn no-hover btn-register">
                                        <span>Registrarse</span>
                                    </a>
                                </div>
                                </>
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
        <PopupLayout isShowwing={showWelcome} showingCallback={openWelcome}>
            <PopupWelcome />
        </PopupLayout>
        </>
    )
}

export default Header;